"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _es6Promise = _interopRequireDefault(require("es6-promise"));

require("whatwg-fetch");

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

_es6Promise.default.polyfill();

var BaseForm = /*#__PURE__*/function (_React$Component) {
  _inherits(BaseForm, _React$Component);

  function BaseForm(props) {
    var _this;

    _classCallCheck(this, BaseForm);

    _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
    _this.state = {
      form: {
        isEditable: false,
        error: null,
        invalidFields: {
          fields: [],
          details: {}
        },
        success: false
      },
      editModalOpen: false
    };
    _this.showFormButtons = _this.showFormButtons.bind(_assertThisInitialized(_this));
    _this.showEditLink = _this.showEditLink.bind(_assertThisInitialized(_this));
    _this.setStateProperty = _this.setStateProperty.bind(_assertThisInitialized(_this));
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    _this.topMessage = _this.topMessage.bind(_assertThisInitialized(_this));
    _this.resetEditMode = _this.resetEditMode.bind(_assertThisInitialized(_this));
    _this.openEditModal = _this.openEditModal.bind(_assertThisInitialized(_this));
    _this.closeEditModal = _this.closeEditModal.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(BaseForm, [{
    key: "resetEditMode",
    value: function resetEditMode() {
      this.setState(function (prev) {
        prev.form.error = null;
        prev.form.invalidFields = {
          fields: [],
          details: {}
        };
        return prev;
      });
    }
  }, {
    key: "showFormButtons",
    value: function showFormButtons() {
      var t = this.props.t; // if (this.state.form.isEditable)

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "button-group"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        onClick: this.handleSubmit,
        className: "btn"
      }, t('save')), /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn--secondary",
        type: "button",
        onClick: this.closeEditModal
      }, t('cancel')));
    }
  }, {
    key: "openEditModal",
    value: function openEditModal() {
      this.setState({
        editModalOpen: true
      });
    }
  }, {
    key: "closeEditModal",
    value: function closeEditModal() {
      this.setState({
        editModalOpen: false
      });
      this.resetEditMode();
    }
  }, {
    key: "showEditLink",
    value: function showEditLink() {
      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn--icon edit-link",
        onClick: this.openEditModal,
        title: t('edit')
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon icon-edit"
      }));
    }
  }, {
    key: "setStateProperty",
    value: function setStateProperty(field, value) {
      this.setState(function (prev) {
        _lodash.default.set(prev, field, value);

        return prev;
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      throw new Error('You have to implement this method in your component');
    }
  }, {
    key: "topMessage",
    value: function topMessage() {
      var t = this.props.t;
      if (this.state.form.error) return /*#__PURE__*/_react.default.createElement("div", {
        "data-abide-error": true,
        role: "alert",
        className: "alert callout"
      }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("i", {
        className: "fi-warning"
      }), t(this.state.form.error)));else if (this.state.form.success) return /*#__PURE__*/_react.default.createElement("div", {
        className: "success callout",
        "data-closable": "slide-out-right"
      }, /*#__PURE__*/_react.default.createElement("p", null, t('Record saved successfully')));
    }
  }]);

  return BaseForm;
}(_react.default.Component);

BaseForm.propTypes = {
  t: _propTypes.default.func.isRequired
};
var _default = BaseForm;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/base-form/index.js
// module id = 44
// module chunks = 0